import { useLang } from 'hooks/lang';

import { ProjectStatusConfig, TaskStatusConfig } from 'entities';

import { Dot, DropdownMenu, DropdownMenuItem, Skeleton } from 'components/Blocks';
import { ChevronDownIcon } from 'components/Icons';
import { cn } from 'styles';

interface SelectStatusProps {
  value: string;
  onChange: (value: string) => void;
  statusConfig: Record<string, TaskStatusConfig> | Record<string, ProjectStatusConfig>;

  disabled?: boolean;
  loading?: boolean;
  className?: string;
}

export function StatusSelect({
  value,
  disabled,
  onChange,
  loading,
  statusConfig,
  className,
}: SelectStatusProps) {
  const { t } = useLang();

  const reactSelectOptions = Object.values(statusConfig)
    .map(({ code, getLabel, ...rest }) => ({
      value: code,
      label: getLabel(t),
      code,
      getLabel,
      ...rest,
    }))
    .filter(({ displayOnSelect }) => displayOnSelect);

  const reactSelectValue = reactSelectOptions.find((option) => option.value === value)!;

  return loading ? (
    <Skeleton width={110} height={30} />
  ) : (
    <DropdownMenu
      align="start"
      trigger={
        <button
          type="button"
          disabled={disabled || !!(reactSelectValue as TaskStatusConfig)?.disableIfSelected}
          style={{ backgroundColor: reactSelectValue?.color }}
          className={cn(
            'inline-flex min-h-7 items-center justify-between gap-2 rounded-sm px-2 text-white',
            className,
          )}
        >
          {reactSelectValue?.getLabel(t)}
          <ChevronDownIcon />
        </button>
      }
    >
      {reactSelectOptions.map(({ color, label, code }) => (
        <DropdownMenuItem key={code} onClick={() => onChange(code)} className="cursor-pointer">
          <Dot color={color} />

          <span>{label}</span>
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
}
